import { render, staticRenderFns } from "./DetailDoctor.vue?vue&type=template&id=63b179d5&scoped=true&"
import script from "./DetailDoctor.vue?vue&type=script&lang=js&"
export * from "./DetailDoctor.vue?vue&type=script&lang=js&"
import style0 from "./DetailDoctor.vue?vue&type=style&index=0&id=63b179d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b179d5",
  null
  
)

export default component.exports